import { createContext, useContext } from 'react';

import { InsurancePaymentIntentData } from '@/types/insurance';

export type PaymentIntentContextProps = {
  data?: InsurancePaymentIntentData;
  offerOrigin?: 'tracking_email' | 'tracking_page';
  isThankYouShown: boolean;
  confirmPaymentIntent: () => Promise<void>;
  failPaymentIntent: () => void;
  continueToPayment: () => void;
  isContinuingToPayment: boolean;
  continueToPaymentError?: string;
};

export const PaymentIntentContext = createContext<PaymentIntentContextProps>({
  isThankYouShown: false,
  confirmPaymentIntent: async () => {},
  failPaymentIntent: () => {},
  continueToPayment: () => {},
  isContinuingToPayment: false,
});

export const usePaymentIntentContext = () => {
  const { data, ...rest } = useContext(PaymentIntentContext);
  if (!data) {
    throw new Error('No payment intent data found in context.');
  }
  return { data, ...rest };
};
